export const getZodSchemaErrors = (parsedData: any) => {
  const errors: { [k: string]: string } = {};
  parsedData.error.errors.forEach(
    (e: { path: { toString: () => string | number }[]; message: string }) => {
      if (e.path[0]) errors[e.path[0].toString()] = e.message;
    }
  );
  return errors;
};
